'use strict';

// Promise
if (typeof Promise === 'undefined') {
  require('promise/lib/rejection-tracking').enable();
  if (window) {
    window.Promise = require('promise/lib/es6-extensions.js');
  }
}

// Fetch API
require('isomorphic-fetch');

// MatchMedia
if (window) {
  require('matchmedia-polyfill');
  require('matchmedia-polyfill/matchMedia.addListener');
}

// Console image
if (window) {
  window.console.logo = require('../polyfills/console-logo');
}

// localStorage
if (window) {
  require('../polyfills/local-storage');
}

// Object assign
Object.assign = require('object-assign');
// Object keys
Object.keys = require('../polyfills/object-keys');
// Object equals
Object.equals = require('../polyfills/object-equals');
// Array some
Array.prototype.some = require('../polyfills/array-some');
// Array fill
Array.prototype.fill = require('../polyfills/array-fill');
// Array every
Array.prototype.every = require('../polyfills/array-every');
String.prototype.startsWith = require('../polyfills/string-startsWith');

if (process.env.NODE_ENV === 'test') {
  require('raf').polyfill(global);
}



//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 703
// module chunks = 0